import { SITE_FOOTER_LINKS_GRID_NAME } from '../constants';


export const getLinkGridName = id => `${SITE_FOOTER_LINKS_GRID_NAME}_${id}`;
